import { SuggestionsState } from '@/store/suggestions/types';

export default <SuggestionsState>{
    latestSuggestions: {},
};
